let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dchHI")).then(() => parcelRequire('7WQQ0'));